import { Body1Strong, Caption1 } from '@fluentui/react-components';
import { formatTND, formatUSD } from '../../utils/currency';

export const CurrencyDisplay = ({ usdAmount, tndAmount }: { usdAmount: number; tndAmount: number }) => (
  <div>
    <Body1Strong>{formatTND(tndAmount)}</Body1Strong>
    <Caption1>{formatUSD(usdAmount)}</Caption1>
  </div>
);
